import { render } from "./VZMultiSelect.vue?vue&type=template&id=031c053f&ts=true"
import script from "./VZMultiSelect.vue?vue&type=script&lang=ts"
export * from "./VZMultiSelect.vue?vue&type=script&lang=ts"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./VZMultiSelect.vue?vue&type=style&index=1&id=031c053f&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__